import React from 'react'
import ReactDOM from 'react-dom/client'
import './i18n'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App.tsx'
import VerifyEmailPage from './components/VerifyEmailPage/VerifyEmailPage.tsx'
import AdminApp from './admin/AdminApp.tsx'
import DealerApp from './dealer/DealerApp.tsx'
import { isDealerPortal } from './dealer/portal'
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy.tsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* портал дилера живёт на отдельном хосте той же сборки (см. dealer/portal.ts) */}
      {isDealerPortal() ? (
        <DealerApp />
      ) : (
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<App />} />
        </Routes>
      )}
    </BrowserRouter>
  </React.StrictMode>,
)
